module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.response !== null) ? _c('div', [_c('document-container', {
    attrs: {
      "body": [],
      "footer": [],
      "documentType": "portfolio",
      "orientation": "portrait"
    },
    scopedSlots: _vm._u([{
      key: "raw-header",
      fn: function() {
        return [_c('header', {
          staticClass: "raw-header"
        }, [_c('div', {
          staticClass: "header-disclaimer"
        }, [_c('strong', [_vm._v("WERBEMITTEILUNG")]), _vm._v(" "), _c('div', {
          staticStyle: {
            "top": "6px",
            "position": "relative"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.response.portfolioName) + "\n          ")])]), _vm._v(" "), _c('img', {
          staticClass: "logo",
          attrs: {
            "src": _vm.logo,
            "alt": ""
          }
        })])]
      },
      proxy: true
    }], null, false, 1048575800)
  }, [_vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h1', [_vm._v("PORTFOLIO SIMULATION")]), _vm._v(" "), _c('h2', [_vm._v("IHR PORTFOLIOVORSCHLAG IM ÜBERBLICK")])]), _vm._v(" "), _c('div', {
    staticClass: "page-disclaimer"
  }, [_vm._v("\n        Rechtliche Hinweise:\n        "), _c('br'), _vm._v(" Diese Information ist als Werbung im Sinne des Wertpapierhandelsgesetzes und der EU-Prospektverordnung anzusehen. Das heißt, sie genügt nicht den rechtlichen Anforderungen für Finanzinstrumente und Vermögensanlagen. Es handelt sich um die unveränderte Weitergabe einer Marktidee bzw. einer sonstigen Marktinformation durch die Sie betreuende Sparkasse. Bezüglich weiterer Informationen sowie der Offenlegung möglicher Interessenkonflikte wird auf die Homepage Ihrer Sparkasse verwiesen. Die Publikation stellt keine Anlageberatung oder Handlungsempfehlung in Bezug auf die genannten Finanzinstrumente bzw. Vermögensanlagen seitens der Sparkasse dar. Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.\n        "), _c('br'), _vm._v(" Die genannten Finanzinstrumente bzw. Vermögensanlagen werden lediglich in Kurzform beschrieben. Eine Anlageentscheidung sollte nur auf Grundlage der Informationen in den rechtlich verbindlichen Dokumenten wie dem Wertpapier- oder Verkaufsprospekt, den Endgültigen Bedingungen, dem Basisinformationsblatt und den Jahres- bzw. Halbjahresberichten der Vermögensanlagen erfolgen, die Sie bei Ihrer Sparkasse, auf Verlangen in Papierform, kostenlos erhalten.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-footer"
    },
    slot: "raw-footer"
  }, [_c('div', {
    staticClass: "disclaimer-date"
  }, [_vm._v("\n        Erstellt am " + _vm._s(_vm.$options.filters.date(new Date(), 'DD.MM.YYYY HH:mm')) + "\n      ")])])]), _vm._v(" "), _c('document-container', {
    attrs: {
      "body": [],
      "footer": [],
      "header": [{
        type: 'Pagetitle',
        title: 'Aufteilung',
        position: 'header',
        sort: 1,
        shared: true,
      }],
      "logo": _vm.logo,
      "documentType": "portfolio",
      "orientation": "portrait"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Portfoliostruktur")]), _vm._v(" "), _c('table', {
    staticClass: "allocation-table"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "350px"
    }
  }, [_c('table', {
    staticClass: "product-table"
  }, [(Object.values(_vm.response.coreInvestmentDistribution).length !== 0) ? _c('tr', {
    staticClass: "allocation-heading"
  }, [_c('td', [_vm._v("Kernanlage")]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercent(Object.values(_vm.response.coreInvestmentDistribution).reduce(function (el, sum) { return sum + el; }), 0))
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.response.coreInvestmentDistribution), function(el, key, index) {
    return (Object.values(_vm.response.coreInvestmentDistribution).length !== 0) ? _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "10px",
        "margin-right": "10px"
      }
    }, [_c('span', {
      staticClass: "dot",
      style: ({
        backgroundColor: _vm.colors[index]
      })
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "235px"
      }
    }, [_vm._v(_vm._s(key))])]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatPercent(el, 0))
      }
    })]) : _vm._e()
  }), _vm._v(" "), (Object.values(_vm.response.satelliteInvestmentDistribution).length !== 0) ? _c('tr', {
    staticClass: "allocation-heading"
  }, [_c('td', [_vm._v("Satellitenanlage")]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercent(Object.values(_vm.response.satelliteInvestmentDistribution).reduce(function (el, sum) { return sum + el; }), 0))
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.response.satelliteInvestmentDistribution), function(el, key, index) {
    return (Object.values(_vm.response.satelliteInvestmentDistribution).length !== 0) ? _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "10px",
        "margin-right": "10px"
      }
    }, [_c('span', {
      staticClass: "dot",
      style: ({
        backgroundColor: _vm.colors[index + Object.values(_vm.response.coreInvestmentDistribution).length]
      })
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "235px"
      }
    }, [_vm._v(_vm._s(key))])]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatPercent(el, 0))
      }
    })]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px 0 0 0"
    }
  }, [(_vm.chartData) ? _c('chart-container', {
    attrs: {
      "chart-data": _vm.chartData.donut1,
      "settings": {
        style: {
          height: 130,
          width: 130
        }
      },
      "chart-type": "ChartDoughnut"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Vermögensaufteilung")]), _vm._v(" "), _c('table', {
    staticClass: "allocation-table"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "350px"
    }
  }, [_c('table', {
    staticClass: "product-table"
  }, _vm._l((_vm.response.assetDistribution), function(el, key, index) {
    return _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "10px",
        "margin-right": "10px"
      }
    }, [_c('span', {
      staticClass: "dot",
      style: ({
        backgroundColor: _vm.colors[index]
      })
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "235px"
      }
    }, [_vm._v(_vm._s(key))])]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatPercent(el, 0))
      }
    })])
  }), 0)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px 0 0 0"
    }
  }, [(_vm.chartData) ? _c('chart-container', {
    attrs: {
      "chart-data": _vm.chartData.donut2,
      "settings": {
        style: {
          height: 130,
          width: 130
        }
      },
      "chart-type": "ChartDoughnut"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Währungsaufteilung")]), _vm._v(" "), _c('table', {
    staticClass: "allocation-table"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "350px"
    }
  }, [_c('table', {
    staticClass: "product-table"
  }, _vm._l((_vm.response.currencyDistribution), function(el, key, index) {
    return _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "10px",
        "margin-right": "10px"
      }
    }, [_c('span', {
      staticClass: "dot",
      style: ({
        backgroundColor: _vm.colors[index]
      })
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "235px"
      }
    }, [_vm._v(_vm._s(key))])]), _vm._v(" "), (el >= .01) ? _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatPercent(el, 0))
      }
    }) : _c('td', [_vm._v("<1 %")])])
  }), 0)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px 0 0 0"
    }
  }, [(_vm.chartData) ? _c('chart-container', {
    attrs: {
      "chart-data": _vm.chartData.donut3,
      "settings": {
        style: {
          height: 130,
          width: 130
        }
      },
      "chart-type": "ChartDoughnut"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "page-disclaimer"
  }, [(Object.keys(_vm.response.assetDistribution).includes('Mischprodukte*')) ? _c('div', [_vm._v("\n          * Die Gewichtung der einzelnen Vermögensaufteilung kann höher sein als dargestellt, da sie auch in den Mischfonds enthalten sind.\n        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" Rechtsdokumente finden Sie im Wertpapiervergleich am Ende des Dokumentes.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\n        Quelle Fondsdaten: FE Fundinfo Limited\n        "), _c('br'), _vm._v(" Quelle Berechnung Datenaggregation: Dericon GmbH\n        "), _c('br'), _vm._v(" Die angegebene Vermögensaufteilung bezieht sich auf die Klassifizierungen der Fonds beispielsweise als Aktien-. Renten-, Immobilienfonds. Sie bezieht sich nicht auf die in den jeweiligen Fonds enthaltenen Vermögenswerte. Die angegebene Währungsaufteilung bezieht sich auf die Fondswährungen und nicht auf die in den jeweiligen Fonds enthaltenen Vermögenswerte.\n        "), _c('br'), _vm._v(" Bitte beachten Sie: Die Auswahl der dargestellten Investments und Angaben zu deren Gewichtung basieren auf Vorgaben der Sie betreuenden Sparkasse.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-footer"
    },
    slot: "raw-footer"
  }, [_c('div', {
    staticClass: "disclaimer-date"
  }, [_vm._v("\n          Erstellt am " + _vm._s(_vm.$options.filters.date(new Date(), 'DD.MM.YYYY HH:mm')) + "\n        ")])])])]), _vm._v(" "), _c('document-container', {
    attrs: {
      "body": [],
      "footer": [],
      "header": [{
        type: 'Pagetitle',
        title: 'Wertentwicklung',
        position: 'header',
        sort: 1,
        shared: true,
      }],
      "logo": _vm.logo,
      "documentType": "portfolio",
      "orientation": "portrait"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('chart-container', {
    attrs: {
      "chartData": _vm.developmentChart,
      "chartType": 'ChartPortfolioHistory',
      "settings": {
        style: {
          width: 520,
          height: 195
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tiny-text",
    staticStyle: {
      "margin-top": "12px",
      "margin-bottom": "24px"
    }
  }, [_vm._v("Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Performance (absolut / p.a.)")]), _vm._v(" "), _c('table', {
    staticClass: "product-table development-table"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('strong', [_vm._v("Werte für")])]), _vm._v(" "), _vm._l((_vm.performanceMap), function(val, key, index) {
    return _c('th', [_c('strong', [_vm._v(_vm._s(val))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('DocTimeFrame', {
      attrs: {
        "years": key
      }
    })], 1)
  })], 2), _vm._v(" "), _vm._l((_vm.portfolioFigures.concat( _vm.coreFigures, _vm.satelliteFigures)), function(row, key) {
    return _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "10px",
        "margin-right": "10px"
      }
    }, [_c('span', {
      staticClass: "dot",
      style: ({
        backgroundColor: _vm.colors[key]
      })
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "118px"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.getGroupName(row.id.type, row.id.name)) + " ")])])]), _vm._v(" "), _vm._l((_vm.performanceMap), function(val, key) {
      return _c('td', [_vm._v("\n            " + _vm._s(_vm.formatPercent(row.performance[key]))), _c('br'), _vm._v(" / " + _vm._s(_vm.formatPercent(row.annualizedPerformance[key])) + "\n          ")])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Volatilität")]), _vm._v(" "), _c('table', {
    staticClass: "product-table development-table"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('strong', [_vm._v("Werte für")])]), _vm._v(" "), _vm._l((_vm.performanceMap), function(val, key, index) {
    return _c('th', [_c('strong', [_vm._v(_vm._s(val))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('DocTimeFrame', {
      attrs: {
        "years": key
      }
    })], 1)
  })], 2), _vm._v(" "), _vm._l((_vm.portfolioFigures.concat( _vm.coreFigures, _vm.satelliteFigures)), function(row, key) {
    return _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "118px"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.getGroupName(row.id.type, row.id.name)) + " ")])])]), _vm._v(" "), _vm._l((_vm.performanceMap), function(val, key) {
      return _c('td', [_vm._v("\n            " + _vm._s(_vm.formatPercent(row.volatility[key])) + "\n          ")])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "tiny-text"
  }, [_vm._v("Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.")]), _vm._v(" "), _c('div', {
    staticClass: "page-disclaimer"
  }, [_vm._v("\n        Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.\n        "), _c('br'), _vm._v("Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.\n        "), _c('br'), _vm._v("Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH\n        "), _c('br'), _vm._v("Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-footer"
    },
    slot: "raw-footer"
  }, [_c('div', {
    staticClass: "disclaimer-date"
  }, [_vm._v("\n        Erstellt am " + _vm._s(_vm.$options.filters.date(new Date(), 'DD.MM.YYYY HH:mm')) + "\n      ")])])]), _vm._v(" "), _c('document-container', {
    attrs: {
      "body": [],
      "footer": [],
      "header": [{
        type: 'Pagetitle',
        title: 'Wertentwicklung',
        position: 'header',
        sort: 1,
        shared: true,
      }],
      "logo": _vm.logo,
      "documentType": "portfolio",
      "orientation": "portrait"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Größter Verlust")]), _vm._v(" "), _c('table', {
    staticClass: "product-table development-table"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('strong', [_vm._v("Werte für")])]), _vm._v(" "), _vm._l((_vm.maxDrawdownMap), function(val) {
    return _c('th', [_c('strong', [_vm._v(_vm._s(val))])])
  })], 2), _vm._v(" "), _vm._l((_vm.portfolioFigures.concat( _vm.coreFigures, _vm.satelliteFigures)), function(row, key) {
    return (row.maxDrawdown !== null) ? _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "118px"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.getGroupName(row.id.type, row.id.name)) + " ")])])]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.formatPercent(row.maxDrawdown.relativeLoss)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.formatDays(row.maxDrawdown.lossPeriodInDays)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$options.filters.date(row.maxDrawdown.periodStart)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$options.filters.date(row.maxDrawdown.periodEnd)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.formatDays(row.maxDrawdown.timeToRecoverInDays)) + "\n          ")])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tiny-text",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Rollierende Wertentwicklung über 5 Jahre")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('table', {
    staticClass: "product-table development-table"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('strong', [_vm._v("Werte für")])]), _vm._v(" "), _vm._l((_vm.portfolioFigures[0].yearlyReturns), function(val) {
    return _c('th', {
      staticStyle: {
        "width": "69px"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$options.filters.date(val.startDate, 'DD.MM.YY')))]), _c('br'), _c('strong', [_vm._v("– " + _vm._s(_vm.$options.filters.date(val.endDate, 'DD.MM.YY')))])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('strong', [_vm._v("Portfolio")])]), _vm._v(" "), _vm._l((_vm.portfolioFigures[0].yearlyReturns), function(val) {
    return _c('td', {
      staticStyle: {
        "width": "69px"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatPercent(val.performance)))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('table', {
    staticClass: "product-table development-table"
  }, [(_vm.coreFigures.length > 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('strong', [_vm._v("Kernanlage")])]), _vm._v(" "), _vm._l((_vm.coreFigures[0].yearlyReturns), function(val) {
    return _c('td', {
      staticStyle: {
        "width": "69px"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatPercent(val.performance)))])])
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.productFigures.filter(function (el) { return el.id.identifier.indexOf('CORE') !== -1; })), function(product) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "150px"
      }
    }, [_vm._v("\n            " + _vm._s(product.id.name) + "\n          ")]), _vm._v(" "), _vm._l((product.yearlyReturns), function(val) {
      return _c('td', {
        staticStyle: {
          "width": "69px"
        }
      }, [_vm._v("\n            " + _vm._s(_vm.formatPercent(val.performance)) + "\n          ")])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('table', {
    staticClass: "product-table development-table"
  }, [(_vm.satelliteFigures.length > 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('strong', [_vm._v("Satellitenanlage")])]), _vm._v(" "), _vm._l((_vm.satelliteFigures[0].yearlyReturns), function(val) {
    return _c('td', [_c('strong', [_vm._v(_vm._s(_vm.formatPercent(val.performance)))])])
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.productFigures.filter(function (el) { return el.id.identifier.indexOf('SATELLITE') !== -1; })), function(product) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "150px"
      }
    }, [_vm._v("\n            " + _vm._s(product.id.name) + "\n          ")]), _vm._v(" "), _vm._l((product.yearlyReturns), function(val) {
      return _c('td', {
        staticStyle: {
          "width": "69px"
        }
      }, [_vm._v("\n            " + _vm._s(_vm.formatPercent(val.performance)) + "\n          ")])
    })], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tiny-text",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "page-disclaimer"
  }, [_vm._v("\n        Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.\n        "), _c('br'), _vm._v("Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.\n        "), _c('br'), _vm._v("Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH\n        "), _c('br'), _vm._v("Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-footer"
    },
    slot: "raw-footer"
  }, [_c('div', {
    staticClass: "disclaimer-date"
  }, [_vm._v("\n        Erstellt am " + _vm._s(_vm.$options.filters.date(new Date(), 'DD.MM.YYYY HH:mm')) + "\n      ")])])]), _vm._v(" "), (_vm.benchmarkFigures.length !== 0) ? _c('document-container', {
    attrs: {
      "body": [],
      "footer": [],
      "header": [{
        type: 'Pagetitle',
        title: 'Portfolio vs. Benchmark',
        position: 'header',
        sort: 1,
        shared: true,
      }],
      "logo": _vm.logo,
      "documentType": "portfolio",
      "orientation": "portrait"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('chart-container', {
    attrs: {
      "chartData": _vm.benchmarkChart,
      "chartType": 'ChartPortfolioHistory',
      "settings": {
        style: {
          width: 520,
          height: 195
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tiny-text",
    staticStyle: {
      "margin-top": "12px",
      "margin-bottom": "24px"
    }
  }, [_vm._v("Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.")]), _vm._v(" "), (_vm.reducedPortfolioAndBenchmarkChart) ? _c('chart-container', {
    attrs: {
      "chartData": _vm.reducedPortfolioAndBenchmarkChart,
      "chartType": 'ChartPortfolioHistory',
      "settings": {
        style: {
          width: 520,
          height: 195
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.reducedPortfolioAndBenchmarkChart) ? _c('div', {
    staticClass: "tiny-text",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.\n      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.reducedPortfolioAndBenchmarkChart) ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "page-disclaimer"
  }, [_vm._v("\n        Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.\n        "), _c('br'), _vm._v("Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.\n        "), _c('br'), _vm._v("Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH\n        "), _c('br'), _vm._v("Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.reducedPortfolioAndBenchmarkChart) ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('pagebreak')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Performance (absolut / p.a.)")]), _vm._v(" "), _c('table', {
    staticClass: "product-table development-table"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('strong', [_vm._v("Werte für")])]), _vm._v(" "), _vm._l((_vm.performanceMap), function(val, key, index) {
    return _c('th', [_c('strong', [_vm._v(_vm._s(val))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('DocTimeFrame', {
      attrs: {
        "years": key
      }
    })], 1)
  })], 2), _vm._v(" "), _vm._l((_vm.portfolioFigures.concat( _vm.benchmarkFigures)), function(row, key) {
    return _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "10px",
        "margin-right": "10px"
      }
    }, [_c('span', {
      staticClass: "dot",
      style: ({
        backgroundColor: _vm.colors[key]
      })
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "118px"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.getGroupName(row.id.type, row.id.name)) + " ")])])]), _vm._v(" "), _vm._l((_vm.performanceMap), function(val, key) {
      return _c('td', [_vm._v("\n            " + _vm._s(_vm.formatPercent(row.performance[key]))), _c('br'), _vm._v(" / " + _vm._s(_vm.formatPercent(row.annualizedPerformance[key])) + "\n          ")])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Volatilität")]), _vm._v(" "), _c('table', {
    staticClass: "product-table development-table"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('strong', [_vm._v("Werte für")])]), _vm._v(" "), _vm._l((_vm.performanceMap), function(val, key, index) {
    return _c('th', [_c('strong', [_vm._v(_vm._s(val))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('DocTimeFrame', {
      attrs: {
        "years": key
      }
    })], 1)
  })], 2), _vm._v(" "), _vm._l((_vm.portfolioFigures.concat( _vm.benchmarkFigures)), function(row, key) {
    return _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "118px"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.getGroupName(row.id.type, row.id.name)) + " ")])])]), _vm._v(" "), _vm._l((_vm.performanceMap), function(val, key) {
      return _c('td', [_vm._v("\n            " + _vm._s(_vm.formatPercent(row.volatility[key])) + "\n          ")])
    })], 2)
  })], 2)]), _vm._v(" "), (_vm.reducedPortfolioAndBenchmarkChart) ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Größter Verlust")]), _vm._v(" "), _c('table', {
    staticClass: "product-table development-table"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('strong', [_vm._v("Werte für")])]), _vm._v(" "), _vm._l((_vm.maxDrawdownMap), function(val) {
    return _c('th', [_c('strong', [_vm._v(_vm._s(val))])])
  })], 2), _vm._v(" "), _vm._l((_vm.portfolioFigures.concat( _vm.benchmarkFigures)), function(row, key) {
    return (row.maxDrawdown !== null) ? _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "118px"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.getGroupName(row.id.type, row.id.name)) + " ")])])]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.formatPercent(row.maxDrawdown.relativeLoss)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.formatDays(row.maxDrawdown.lossPeriodInDays)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$options.filters.date(row.maxDrawdown.periodStart)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$options.filters.date(row.maxDrawdown.periodEnd)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.formatDays(row.maxDrawdown.timeToRecoverInDays)) + "\n          ")])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "tiny-text"
  }, [_vm._v("Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "page-disclaimer"
  }, [_vm._v("\n        Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.\n        "), _c('br'), _vm._v("Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.\n        "), _c('br'), _vm._v("Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH\n        "), _c('br'), _vm._v("Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-footer"
    },
    slot: "raw-footer"
  }, [_c('div', {
    staticClass: "disclaimer-date"
  }, [_vm._v("\n        Erstellt am " + _vm._s(_vm.$options.filters.date(new Date(), 'DD.MM.YYYY HH:mm')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.benchmarkFigures.length !== 0 && !_vm.reducedPortfolioAndBenchmarkChart) ? _c('document-container', {
    attrs: {
      "body": [],
      "footer": [],
      "header": [{
        type: 'Pagetitle',
        title: 'Portfolio vs. Benchmark',
        position: 'header',
        sort: 1,
        shared: true,
      }],
      "logo": _vm.logo,
      "documentType": "portfolio",
      "orientation": "portrait"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Größter Verlust")]), _vm._v(" "), _c('table', {
    staticClass: "product-table development-table"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('strong', [_vm._v("Werte für")])]), _vm._v(" "), _vm._l((_vm.maxDrawdownMap), function(val) {
    return _c('th', [_c('strong', [_vm._v(_vm._s(val))])])
  })], 2), _vm._v(" "), _vm._l((_vm.portfolioFigures.concat( _vm.benchmarkFigures)), function(row, key) {
    return (row.maxDrawdown !== null) ? _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "top",
        "width": "118px"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.getGroupName(row.id.type, row.id.name)) + " ")])])]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.formatPercent(row.maxDrawdown.relativeLoss)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.formatDays(row.maxDrawdown.lossPeriodInDays)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$options.filters.date(row.maxDrawdown.periodStart)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$options.filters.date(row.maxDrawdown.periodEnd)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.formatDays(row.maxDrawdown.timeToRecoverInDays)) + "\n          ")])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tiny-text",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "page-disclaimer"
  }, [_vm._v("\n        Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.\n        "), _c('br'), _vm._v("Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.\n        "), _c('br'), _vm._v("Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH\n        "), _c('br'), _vm._v("Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-footer"
    },
    slot: "raw-footer"
  }, [_c('div', {
    staticClass: "disclaimer-date"
  }, [_vm._v("\n        Erstellt am " + _vm._s(_vm.$options.filters.date(new Date(), 'DD.MM.YYYY HH:mm')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), _c('document-container', {
    attrs: {
      "body": [],
      "footer": [],
      "header": [{
        type: 'Pagetitle',
        title: 'Risikobetrachtung',
        position: 'header',
        sort: 1,
        shared: true,
      }],
      "logo": _vm.logo,
      "documentType": "portfolio",
      "orientation": "portrait"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h3', [_vm._v("Historische Häufigkeiten der Monatsrenditen")]), _vm._v(" "), _c('table', {
    staticClass: "product-table development-table",
    staticStyle: {
      "display": "inline-table",
      "width": "250px",
      "margin-right": "20px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Monatsrenditen")]), _vm._v(" "), _c('th', [_vm._v("Häufigkeit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.negativeReturns), function(value, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(value.label))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatPercent(_vm.getDistributionValue(key)))
      }
    })])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "product-table development-table",
    staticStyle: {
      "display": "inline-table",
      "width": "250px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Monatsrenditen")]), _vm._v(" "), _c('th', [_vm._v("Häufigkeit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.positiveReturns), function(value, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(value.label))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatPercent(_vm.getDistributionValue(key)))
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [(_vm.chartData) ? _c('chart-container', {
    attrs: {
      "chart-data": _vm.chartData.bar,
      "settings": {
        style: {
          height: 170,
          width: 520
        }
      },
      "chart-type": "ChartPortfolioBar"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tiny-text",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("Betrachtungszeitraum: " + _vm._s(_vm.$options.filters.date(_vm.response.figures[0].monthlyReturnStatistics.distribution.startDate)) + " - " + _vm._s(_vm.$options.filters.date(_vm.response.figures[0].monthlyReturnStatistics.distribution.endDate)))]), _vm._v(" "), _c('div', {
    staticClass: "tiny-text"
  }, [_vm._v("Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "250px",
      "vertical-align": "top"
    }
  }, [_c('h3', [_vm._v("Weitere Kennzahlen")]), _vm._v(" "), _c('table', {
    staticClass: "product-table development-table"
  }, _vm._l((_vm.monthlyStats), function(val) {
    return _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(val.label))])]), _vm._v(" "), (!val.plain) ? _c('td', [_vm._v(_vm._s(_vm.formatPercent(_vm.response.figures[0].monthlyReturnStatistics[val.path])))]) : _c('td', [_vm._v(_vm._s(_vm.response.figures[0].monthlyReturnStatistics[val.path] !== null ? _vm.response.figures[0].monthlyReturnStatistics[val.path] : '—'))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tiny-text",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("Betrachtungszeitraum: " + _vm._s(_vm.$options.filters.date(_vm.response.figures[0].monthlyReturnStatistics.distribution.startDate)) + " - " + _vm._s(_vm.$options.filters.date(_vm.response.figures[0].monthlyReturnStatistics.distribution.endDate)))]), _vm._v(" "), _c('div', {
    staticClass: "tiny-text"
  }, [_vm._v("Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "250px",
      "margin-left": "20px",
      "vertical-align": "top"
    }
  }, [_c('h3', [_vm._v("Erläuterung")]), _vm._v(" "), _c('p', [_vm._v("Dargestellt werden Häufigkeiten, in denen über einen Betrachtungszeitraum von 10 Jahren bestimmte Monatsrenditen über- oder unterschritten wurden. Der Wert bei <-3% sagt beispielsweise aus, in wieviel Prozent der Fälle im Betrachtungszeitraum die Monatsrendite kleiner als -3% war. Die Kennzahlen auf der linken Seite beziehen sich auf den gleichen Betrachtungszeitraum und ebenfalls auf Monatsrenditen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "page-disclaimer"
  }, [_vm._v("\n        Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.\n        "), _c('br'), _vm._v("Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.\n        "), _c('br'), _vm._v("Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH\n        "), _c('br'), _vm._v("Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-footer"
    },
    slot: "raw-footer"
  }, [_c('div', {
    staticClass: "disclaimer-date"
  }, [_vm._v("\n        Erstellt am " + _vm._s(_vm.$options.filters.date(new Date(), 'DD.MM.YYYY HH:mm')) + "\n      ")])])]), _vm._v(" "), _c('document-container', {
    attrs: {
      "body": [],
      "footer": [],
      "header": [{
        type: 'Pagetitle',
        title: 'Regionale Gewichtung',
        position: 'header',
        sort: 1,
        shared: true,
      }],
      "logo": _vm.logo,
      "documentType": "portfolio",
      "orientation": "portrait"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_vm._l((_vm.continents), function(continent) {
    return _c('div', {
      staticClass: "continent",
      style: ({
        top: continent.top + 'px',
        left: continent.left + 'px'
      })
    }, [_c('chart-container', {
      staticStyle: {
        "position": "absolute",
        "z-index": "50"
      },
      attrs: {
        "chart-data": _vm.getRegionChartData(continent),
        "settings": {
          style: {
            height: 80,
            width: 80
          },
        },
        "chart-type": "ChartDoughnut"
      }
    }), _vm._v(" "), _c('img', {
      staticStyle: {
        "position": "absolute",
        "left": "0",
        "top": "0"
      },
      attrs: {
        "src": require("./Ellipse 51.png")
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "50px",
        "z-index": "100"
      }
    }, [_vm._v("\n          " + _vm._s(continent.name)), _c('br'), _vm._v(" " + _vm._s(_vm.formatPercent((_vm.response.regionalDistribution[continent.key] || 0))) + "\n        ")])], 1)
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "top": "103px",
      "position": "absolute"
    },
    attrs: {
      "src": "/config/dericon/images/world.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-disclaimer"
  }, [_vm._v("\n        Die Gewichtungen der einzelnen Regionen können höher sein als dargestellt, da sie auch in der globalen Allokation enthalten sind.\n        "), _c('br'), _c('br'), _vm._v(" Quelle Fondsdaten: FE Fundinfo Limited\n        "), _c('br'), _vm._v(" Quelle Berechnung Datenaggregation: Dericon GmbH\n        "), _c('br'), _vm._v(" Die angegebene regionale Gewichtung bezieht sich auf die den Fondsstammdaten genannten Anlageregion der Fonds.\n      ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-footer"
    },
    slot: "raw-footer"
  }, [_c('div', {
    staticClass: "disclaimer-date"
  }, [_vm._v("\n        Erstellt am " + _vm._s(_vm.$options.filters.date(new Date(), 'DD.MM.YYYY HH:mm')) + "\n      ")])])]), _vm._v(" "), _vm._l((_vm.groupedProducts), function(group) {
    return _c('document-container', {
      attrs: {
        "body": [],
        "footer": [],
        "header": [{
          type: 'Pagetitle',
          title: 'Wertpapiervergleich',
          position: 'header',
          sort: 1,
          shared: true,
        }],
        "logo": _vm.logo,
        "documentType": "portfolio",
        "orientation": "portrait"
      }
    }, [_c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('table', {
      staticClass: "product-table comparison-table"
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "width": "123px"
      }
    }, [_c('strong', [_vm._v("Stammdaten")])]), _vm._v(" "), _vm._l((group), function(product) {
      return _c('th', {
        staticStyle: {
          "text-align": "right",
          "width": "123px"
        }
      }, [_c('strong', [_vm._v(_vm._s(product.enriched.displayName))])])
    })], 2), _vm._v(" "), _vm._l((_vm.response.products.structure.columns), function(col) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "123px"
        }
      }, [_c('strong', [_vm._v(" " + _vm._s(col.label) + " ")]), _vm._v(" "), (Object.keys(_vm.comparisonLabelMap).includes(col.label)) ? _c('DocTimeFrame', {
        attrs: {
          "br": false,
          "years": _vm.comparisonLabelMap[col.label]
        }
      }) : _vm._e()], 1), _vm._v(" "), _vm._l((group), function(product) {
        return _c('tablefield', {
          staticStyle: {
            "text-align": "right",
            "width": "123px"
          },
          attrs: {
            "column": col,
            "product": product,
            "secondary-index": 0
          }
        })
      })], 2)
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "tiny-text",
      staticStyle: {
        "margin-top": "12px"
      }
    }, [_vm._v("Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.")])]), _vm._v(" "), _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('div', {
      staticClass: "tiny-text"
    }, [_c('h3', [_vm._v("Verkaufsdokumente")]), _vm._v(" "), _vm._l((group), function(product) {
      return _c('div', {
        staticStyle: {
          "line-height": "7px"
        }
      }, [_c('strong', [_vm._v(_vm._s(product.enriched.displayName))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((product.links), function(link) {
        return [_c('a', {
          staticStyle: {
            "color": "#000"
          },
          attrs: {
            "href": link.link
          }
        }, [_vm._v(_vm._s(link.label) + ": " + _vm._s(link.link))]), _vm._v(" "), _c('br')]
      }), _vm._v(" "), _c('br')], 2)
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('div', {
      staticClass: "page-disclaimer"
    }, [_vm._v("\n        Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.\n        "), _c('br'), _vm._v("Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.\n        "), _c('br'), _vm._v("Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH\n        "), _c('br'), _vm._v("Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.\n      ")])]), _vm._v(" "), _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-footer"
      },
      slot: "raw-footer"
    }, [_c('div', {
      staticClass: "disclaimer-date"
    }, [_vm._v("\n        Erstellt am " + _vm._s(_vm.$options.filters.date(new Date(), 'DD.MM.YYYY HH:mm')) + "\n      ")])])])
  }), _vm._v(" "), _c('document-container', {
    attrs: {
      "body": [],
      "footer": [],
      "header": [{
        type: 'Pagetitle',
        title: 'Rechtliche Hinweise',
        position: 'header',
        sort: 1,
        shared: true,
      }],
      "logo": _vm.logo,
      "documentType": "portfolio",
      "orientation": "portrait"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Bitte beachten Sie:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("Bei den in dieser Präsentation dargestellten Eckpunkten zu Zielvorgaben oder Anforderungen an eine Vermögensanlage und dem dargestellten Anlage- bzw. Umsetzungsvorschlag handelt es sich um Angaben und Vorgaben der Sie beratenden Sparkasse und deren Mitarbeitenden. Enthaltene Darstellungen, insb. Berechnungen oder Simulationen aus den benannten Quellen, dienen ausschließlich als ergänzende Zusatzinformation und stellen keine Anlageberatung durch diese Quellen dar.\n      "), _c('br'), _vm._v("Diese Präsentation enthält nicht alle für den Erwerb etwaiger in der Präsentation dargestellter Finanzinstrumente relevanten Informationen und dient lediglich zu Informationszwecken des jeweiligen Empfängers. Eine detaillierte Beschreibung der Risiken ist dem jeweiligen Verkaufsprospekt (Investmentfonds), Wertpapierprospekt (Inhaberschuldverschreibungen) oder den Sonderbedingungen (Vermögensverwaltungsprodukte) zu entnehmen. Die Darstellung der Finanzinstrumente in dieser Präsentation stellt weder ein Angebot noch eine Anlageberatung oder eine Anlageempfehlung zum Erwerb oder Verkauf von Finanzinstrumenten / Vermögensverwaltungen dar. Die Darstellung einer historischen Entwicklung von Finanzinstrumenten erfolgt auf Euro-Basis, sofern keine anderen Angaben gemacht werden. Diese Präsentation verpflichtet die Sparkasse nicht zur Abgabe eines Angebots oder zum Geschäftsabschluss gegenüber dem Empfänger. Die hierin enthaltenen Meinungen werden ohne Berücksichtigung der Umstände, Ziele oder Bedürfnisse des jeweiligen Empfängers abgegeben. Die Präsentation kann eine individuelle Beratung des Empfängers (z. B. durch eine Bank oder einen Berater) nicht ersetzen.\n      "), _c('br'), _vm._v("Diese Präsentation wurde mit Sorgfalt erstellt. Teilweise werden in dieser Präsentation Meinungsaussagen getroffen. Diese Meinungsaussagen geben die aktuelle Einschätzung der Sparkasse zum Zeitpunkt der Erstellung dieser Präsentation wieder. Die Einschätzung kann sich jederzeit ohne Ankündigung ändern. Die verwendeten Daten stammen teilweise aus Drittquellen, die die Sparkasse nach bestem Wissen als vertrauenswürdig erachtet. Die Sparkasse übernimmt jedoch keine Gewähr für die Vollständigkeit, Aktualität und Richtigkeit der in dieser Präsentation gemachten Angaben und haftet nicht für etwaige Schäden oder Aufwendungen, die aus einem Vertrauen auf die Vollständigkeit, Aktualität und Richtigkeit der aus Drittquellen stammenden Daten resultiert.\n      "), _c('br'), _vm._v("Etwaige in dieser Präsentation erwähnten Finanzinstrumente können mit Risiken verbunden sein, die schwer abzuschätzen und in die Evaluation einer Anlageentscheidung einzubeziehen sind. Die Sparkasse ist bereit, Kunden auf Wunsch weitere Informationen zu den Risiken spezifischer Anlagen zu liefern.\n      "), _c('br'), _vm._v("Auf besondere Verkaufsbeschränkungen und Vertriebsvorschriften in den verschiedenen Rechtsordnungen wird hingewiesen. Insbesondere darf das hierin beschriebene Finanzinstrument weder innerhalb der Vereinigten Staaten von Amerika noch an beziehungsweise zugunsten von US-Personen zum Kauf oder Verkauf angeboten werden.\n      "), _c('br'), _vm._v("Allein verbindliche Grundlage für den Erwerb von Investmentfonds sind die jeweiligen Basisinformationsblätter, die jeweiligen Verkaufsprospekte und die jeweiligen Berichte. Diese erhalten Sie bei Ihrer Sparkasse.\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.customDisclaimer)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Die Verwaltungsgesellschaft des Investmentfonds kann jederzeit beschließen, den Vertrieb einzustellen.\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("© " + _vm._s(_vm.$options.filters.date(new Date(), 'YYYY')) + " Dericon GmbH, Mainzer Landstraße 41–45, 60329 Frankfurt am Main\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-footer"
    },
    slot: "raw-footer"
  }, [_c('div', {
    staticClass: "disclaimer-date"
  }, [_vm._v("\n        Erstellt am " + _vm._s(_vm.$options.filters.date(new Date(), 'DD.MM.YYYY HH:mm')) + "\n      ")])])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22ad46e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portfolio/Portfolio.vue
// module id = 665
// module chunks = 0